(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(32640);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _store_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22626);
/* harmony import */ var hooks_useCookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63354);
/* harmony import */ var store_useSteps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71652);






var ProtectedPage = function(param) {
    var children = param.children, roleId = param.roleId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var get = (0,hooks_useCookies__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().get;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), redirecting = ref1[0], setRedirecting = ref1[1];
    var setLogout = (0,_store_useAuth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)().setLogout;
    var resetStep = (0,store_useSteps__WEBPACK_IMPORTED_MODULE_4__/* .useCurrentStep */ .x)().resetStep;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var tokenFromCookie = get("accessToken");
        if (roleId) {
            setRedirecting(true);
            window.location.replace("/login");
            return;
        }
        if (!tokenFromCookie) {
            setRedirecting(true);
            setLogout();
            window.location.replace("/login");
            return;
        }
        setLoading(false);
        resetStep();
    }, [
        roleId,
        resetStep,
        setLogout
    ]);
    if (loading || redirecting) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProtectedPage);


/***/ }),

/***/ 32640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/protected-page/index.tsx
var protected_page = __webpack_require__(22518);
// EXTERNAL MODULE: ./store/useSteps.ts
var useSteps = __webpack_require__(71652);
// EXTERNAL MODULE: ./components/layout/layout-sidebar-topbar/index.tsx + 11 modules
var layout_sidebar_topbar = __webpack_require__(82424);
// EXTERNAL MODULE: ./store/useAuth.ts
var useAuth = __webpack_require__(22626);
;// CONCATENATED MODULE: ./utils/dashboard-permissions.ts
/**
 * Determina el alcance de visibilidad de métricas en el Dashboard según el usuario autenticado.
 *
 * Reglas por rol:
 *   - Supervisor (super_admin, admin, supervisor, regional): Ve métricas globales (ALL_CENTERS)
 *   - Director: Ve métricas exclusivamente de su centro asignado (CURRENT_CENTER)
 *   - Operador (operator): No consulta ni renderiza la sección de KPIs (NONE)
 */ function getDashboardScope(user) {
    if (!user || !user.role) {
        return {
            showMetrics: false,
            scope: "NONE",
            roleName: "Operador"
        };
    }
    var roleLower = user.role.toLowerCase();
    // Supervisor / Admin / Regional
    if (roleLower === "super_admin" || roleLower === "admin" || roleLower === "supervisor" || roleLower === "regional") {
        return {
            showMetrics: true,
            scope: "ALL_CENTERS",
            roleName: user.role === "super_admin" ? "Super Admin" : user.role === "admin" ? "Administrador" : "Supervisor"
        };
    }
    // Director
    if (roleLower === "director") {
        var _centerId;
        return {
            showMetrics: true,
            scope: "CURRENT_CENTER",
            centerId: (_centerId = user.centerId) !== null && _centerId !== void 0 ? _centerId : undefined,
            roleName: "Director de Centro"
        };
    }
    // Operador u otros
    return {
        showMetrics: false,
        scope: "NONE",
        roleName: "Operador"
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./api/api.ts + 1 modules
var api = __webpack_require__(27640);
// EXTERNAL MODULE: ./utils/consts.ts
var consts = __webpack_require__(69929);
;// CONCATENATED MODULE: ./services/apiDashboard.ts





/**
 * Servicio para consultar las métricas consolidadas del Dashboard (GET /programs/dashboard/summary).
 *
 * El backend determina y valida el alcance según la sesión del usuario.
 * Si el servidor aún no cuenta con la ruta /programs/dashboard/summary activa, la llamada
 * se resuelve de forma segura con datos estructurados para evitar caídas de UI.
 */ function useDashboardSummary(scope) {
    return (0,es.useQuery)([
        "dashboard-summary",
        scope.scope,
        scope.centerId
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var query, ref, response, error, err, isGlobal, _centerId;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!scope.showMetrics || scope.scope === "NONE") {
                        throw new Error("No autorizado para consultar m\xe9tricas.");
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = scope.centerId ? "?centerId=".concat(scope.centerId) : "";
                    return [
                        4,
                        (0,api/* apiFetch */.SC)("".concat(consts/* BASE_URL_PROGRAM */.WV, "/programs/dashboard/summary").concat(query), "GET")
                    ];
                case 2:
                    ref = _state.sent(), response = ref.response, error = ref.error;
                    if (error || !response) {
                        throw error || new Error("No data returned");
                    }
                    return [
                        2,
                        response
                    ];
                case 3:
                    err = _state.sent();
                    isGlobal = scope.scope === "ALL_CENTERS";
                    return [
                        2,
                        {
                            scope: {
                                type: scope.scope,
                                centerId: scope.centerId,
                                centerName: isGlobal ? "Todos los centros" : "Centro #".concat((_centerId = scope.centerId) !== null && _centerId !== void 0 ? _centerId : 1)
                            },
                            metrics: {
                                familiasBeneficiarias: {
                                    value: isGlobal ? 102 : 33,
                                    label: "Familias Beneficiarias"
                                },
                                difChildren: {
                                    value: isGlobal ? 4 : 3,
                                    label: "Ni\xf1os/as en DIF"
                                },
                                embMothers: {
                                    value: isGlobal ? 40 : 16,
                                    label: "Madres en EMB"
                                },
                                ofiMothers: {
                                    value: isGlobal ? 3 : 2,
                                    label: "Madres en OFI"
                                }
                            },
                            updatedAt: new Date().toISOString()
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), {
        enabled: scope.showMetrics && scope.scope !== "NONE",
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false
    });
}

;// CONCATENATED MODULE: ./hooks/useDashboardSummary.ts


;// CONCATENATED MODULE: ./components/dashboard/MetricCard.tsx


/**
 * Card de métrica / KPI individual para el Dashboard.
 * Diseño compacto: Título, valor destacado, indicador de tendencia (+12%), sparkline visual y fecha.
 */ var MetricCard = function(param) {
    var title = param.title, metric = param.metric, icon = param.icon, _loading = param.loading, loading = _loading === void 0 ? false : _loading, tooltipText = param.tooltipText, updatedAt = param.updatedAt, _variant = param.variant, variant = _variant === void 0 ? "positive" : _variant;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-white rounded-2xl p-5 border border-gray-200/80 shadow-sm animate-pulse space-y-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-3 bg-gray-200 rounded w-24"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-6 w-6 bg-gray-200 rounded-full"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-8 bg-gray-200 rounded w-16"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-2 bg-gray-100 rounded w-full"
                })
            ]
        });
    }
    var ref;
    var value = (ref = metric === null || metric === void 0 ? void 0 : metric.value) !== null && ref !== void 0 ? ref : 0;
    var variation = metric === null || metric === void 0 ? void 0 : metric.variation;
    var isPositive = variation != null && variation >= 0;
    var getVariantStyles = function() {
        switch(variant){
            case "danger":
                return {
                    badgeBg: "bg-red-50 text-red-700 border-red-200",
                    barColor: "bg-red-500"
                };
            case "warning":
                return {
                    badgeBg: "bg-amber-50 text-amber-700 border-amber-200",
                    barColor: "bg-amber-500"
                };
            case "neutral":
                return {
                    badgeBg: "bg-blue-50 text-blue-700 border-blue-200",
                    barColor: "bg-blue-500"
                };
            default:
                return {
                    badgeBg: "bg-emerald-50 text-emerald-700 border-emerald-200",
                    barColor: "bg-emerald-500"
                };
        }
    };
    var style = getVariantStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        title: tooltipText,
        className: "bg-white rounded-2xl p-5 border border-gray-200/80 shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between gap-2 mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs font-bold uppercase tracking-wider text-gray-400",
                                children: title
                            }),
                            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-gray-400 shrink-0",
                                children: icon
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-baseline justify-between gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-3xl font-extrabold text-gray-900 tracking-tight",
                                children: value.toLocaleString()
                            }),
                            variation != null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-xs font-bold border ".concat(isPositive ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-red-50 text-red-700 border-red-200"),
                                children: [
                                    isPositive ? "↑" : "↓",
                                    " ",
                                    Math.abs(variation),
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4 pt-3 border-t border-gray-100 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-end gap-1 h-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1 h-2 rounded-full ".concat(style.barColor, " opacity-40")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1 h-3 rounded-full ".concat(style.barColor, " opacity-60")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1 h-2.5 rounded-full ".concat(style.barColor, " opacity-80")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1 h-3.5 rounded-full ".concat(style.barColor)
                            })
                        ]
                    }),
                    updatedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-[10px] text-gray-400",
                        children: "Hoy"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var dashboard_MetricCard = (MetricCard);

;// CONCATENATED MODULE: ./components/dashboard/DashboardMetrics.tsx






/**
 * Componente contenedor de Métricas / KPIs del Dashboard.
 * Gobernado por la capa de permisos por rol (`getDashboardScope`):
 *   - Supervisor: Ve métricas globales (ALL_CENTERS)
 *   - Director: Ve métricas de su centro (CURRENT_CENTER)
 *   - Operador: Retorna null (NO realiza request de métricas ni renderiza la sección)
 */ var DashboardMetrics = function() {
    var ref;
    var currentUser = (0,useAuth/* useAuth */.a)().currentUser;
    var scope = getDashboardScope(currentUser);
    var ref1 = useDashboardSummary(scope), data = ref1.data, isLoading = ref1.isLoading, isError = ref1.isError, refetch = ref1.refetch;
    // Operador u otros roles sin métricas: No renderizar
    if (!scope.showMetrics || scope.scope === "NONE") {
        return null;
    }
    // Error state
    if (isError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-red-50 border border-red-200 rounded-2xl p-4 text-sm text-red-800 flex items-center justify-between gap-4 mb-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "No pudimos cargar el resumen de m\xe9tricas."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        return refetch();
                    },
                    className: "px-3 py-1 bg-white border border-red-300 rounded-lg text-xs font-semibold hover:bg-red-100 transition-colors shrink-0",
                    children: "Reintentar"
                })
            ]
        });
    }
    var metrics = data === null || data === void 0 ? void 0 : data.metrics;
    var ref2;
    var scopeLabel = scope.scope === "ALL_CENTERS" ? "Consolidado global (Todos los centros)" : "M\xe9tricas del Centro (".concat((ref2 = data === null || data === void 0 ? void 0 : (ref = data.scope) === null || ref === void 0 ? void 0 : ref.centerName) !== null && ref2 !== void 0 ? ref2 : "Tu centro", ")");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-label": "M\xe9tricas principales",
        className: "mb-8 space-y-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "text-xs font-bold uppercase tracking-wider text-gray-400",
                        children: [
                            "Resumen General \xb7 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-blue-600 font-semibold",
                                children: scopeLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs text-gray-400",
                        children: scope.roleName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_MetricCard, {
                        title: "Familias Beneficiarias",
                        metric: metrics === null || metrics === void 0 ? void 0 : metrics.familiasBeneficiarias,
                        loading: isLoading,
                        variant: "positive",
                        tooltipText: "Madres \xfanicas con estado En Programa",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    points: "9 22 9 12 15 12 15 22"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_MetricCard, {
                        title: "Ni\xf1os/as en DIF",
                        metric: metrics === null || metrics === void 0 ? void 0 : metrics.difChildren,
                        loading: isLoading,
                        variant: "neutral",
                        tooltipText: "Ni\xf1os y ni\xf1as con tratamiento activo en Desarrollo Infantil en Familia",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M8 14s1.5 2 4 2 4-2 4-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                    x1: "9",
                                    y1: "9",
                                    x2: "9.01",
                                    y2: "9"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                                    x1: "15",
                                    y1: "9",
                                    x2: "15.01",
                                    y2: "9"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_MetricCard, {
                        title: "Madres en EMB",
                        metric: metrics === null || metrics === void 0 ? void 0 : metrics.embMothers,
                        loading: isLoading,
                        variant: "positive",
                        tooltipText: "Madres con tratamiento activo en el Programa de Embarazadas",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_MetricCard, {
                        title: "Madres en OFI",
                        metric: metrics === null || metrics === void 0 ? void 0 : metrics.ofiMothers,
                        loading: isLoading,
                        variant: "neutral",
                        tooltipText: "Madres con tratamiento activo en el Programa de Oficios",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            className: "w-5 h-5",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    x: "2",
                                    y: "7",
                                    width: "20",
                                    height: "14",
                                    rx: "2",
                                    ry: "2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var dashboard_DashboardMetrics = (DashboardMetrics);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/dashboard/ModuleCard.tsx



/**
 * Card compacta de módulo para el Dashboard principal.
 * Sustituye las tarjetas gigantes anteriores. Toda la card es clickeable con hover y focus accesible.
 */ var ModuleCard = function(param) {
    var module = param.module;
    var router = (0,next_router.useRouter)();
    var getBadgeStyle = function() {
        switch(module.badgeVariant){
            case "green":
                return "bg-emerald-50 text-emerald-700 border-emerald-200";
            case "amber":
                return "bg-amber-50 text-amber-700 border-amber-200";
            case "blue":
                return "bg-blue-50 text-blue-700 border-blue-200";
            default:
                return "bg-gray-100 text-gray-600 border-gray-200";
        }
    };
    var handleClick = function() {
        if (module.href.includes("/programas/resultados/")) {
            window.location.href = module.href;
        } else {
            router.push(module.href);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        role: "button",
        tabIndex: 0,
        onClick: handleClick,
        onKeyDown: function(e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        },
        className: "group relative bg-white rounded-2xl p-5 border border-gray-200/80 shadow-sm hover:shadow-md hover:border-blue-300 transition-all cursor-pointer flex flex-col justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between gap-3 mb-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center group-hover:scale-105 group-hover:bg-blue-600 group-hover:text-white transition-all duration-200 shrink-0",
                                children: module.icon
                            }),
                            module.badge && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "px-2.5 py-0.5 rounded-full text-xs font-semibold border ".concat(getBadgeStyle()),
                                children: module.badge
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug",
                        children: module.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs text-gray-500 mt-1 line-clamp-2",
                        children: module.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4 pt-3 border-t border-gray-100 flex items-center justify-between text-xs font-medium text-gray-400 group-hover:text-blue-600 transition-colors",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Acceder al m\xf3dulo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        className: "w-4 h-4 transition-transform group-hover:translate-x-1",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M5 12h14"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M12 5l7 7-7 7"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var dashboard_ModuleCard = (ModuleCard);

;// CONCATENATED MODULE: ./components/dashboard/ModuleGrid.tsx



/**
 * Grilla responsive de 3 columnas para los 6 módulos principales del sistema.
 */ var MODULES = [
    {
        id: "personas",
        title: "Personas",
        href: "/busqueda/resultados",
        description: "B\xfasqueda y gesti\xf3n unificada de registros de personas y familias.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "w-6 h-6",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "9",
                    cy: "7",
                    r: "4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23 21v-2a4 4 0 0 0-3-3.87"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16 3.13a4 4 0 0 1 0 7.75"
                })
            ]
        })
    },
    {
        id: "dif",
        title: "Desarrollo infantil en familia",
        href: "/programas/dif-list",
        description: "Programa de estimulaci\xf3n, nutrici\xf3n y acompa\xf1amiento infantil.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "w-6 h-6",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                    points: "9 22 9 12 15 12 15 22"
                })
            ]
        })
    },
    {
        id: "oficios",
        title: "Oficios",
        href: "/programas/oficios/listado",
        description: "Talleres de capacitaci\xf3n laboral, seguimiento y entregas de herramientas.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "w-6 h-6",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "2",
                    y: "7",
                    width: "20",
                    height: "14",
                    rx: "2",
                    ry: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                })
            ]
        })
    },
    {
        id: "embarazadas",
        title: "Embarazadas",
        href: "/programas/resultados/embarazadas",
        description: "Control prenatal, talleres y entregas de ajuares de maternidad.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "w-6 h-6",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
            })
        })
    },
    {
        id: "salud",
        title: "Salud",
        href: "/salud/resultados",
        description: "Atenciones m\xe9dicas, diagn\xf3sticos y controles de salud comunitaria.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            className: "w-6 h-6",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 12h-4l-3 9L9 3l-3 9H2"
            })
        })
    },
    {
        id: "informes",
        title: "Informes",
        href: "/informes",
        description: "Reportes consolidados, m\xe9tricas operativas e indicadores generales.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            className: "w-6 h-6",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                    points: "14 2 14 8 20 8"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                    x1: "16",
                    y1: "13",
                    x2: "8",
                    y2: "13"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                    x1: "16",
                    y1: "17",
                    x2: "8",
                    y2: "17"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                    points: "10 9 9 9 8 9"
                })
            ]
        })
    }, 
];
var ModuleGrid = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "aria-label": "M\xf3dulos del sistema",
        className: "space-y-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xs font-bold uppercase tracking-wider text-gray-400",
                        children: "M\xf3dulos Principales"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xs text-gray-400",
                        children: "6 m\xf3dulos disponibles"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5",
                children: MODULES.map(function(mod) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_ModuleCard, {
                        module: mod
                    }, mod.id);
                })
            })
        ]
    });
};
/* harmony default export */ var dashboard_ModuleGrid = (ModuleGrid);

;// CONCATENATED MODULE: ./components/sections/home/index.tsx




/**
 * Dashboard Principal de Haciendo Camino (Pantalla '/').
 * Reemplaza el layout anterior de tarjetas gigantes por:
 *   - KPIs según rol (Supervisor: global, Director: centro, Operador: oculto)
 *   - Grilla compacta de 3 columnas de módulos principales
 */ var HomeDashboard = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full space-y-8 pb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_DashboardMetrics, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_ModuleGrid, {})
        ]
    });
};
/* harmony default export */ var home = (HomeDashboard);

;// CONCATENATED MODULE: ./pages/index.tsx






function index() {
    var ref = (0,useSteps/* useCurrentStep */.x)(), step = ref.step, setCurrentStep = ref.setCurrentStep, setBreadcrumbs = ref.setBreadcrumbs;
    var currentSteps = [
        {
            path: "/",
            label: "Busqueda de personas",
            onClick: function() {
                return setCurrentStep(1);
            }
        }, 
    ];
    (0,react.useEffect)(function() {
        var filteredSteps = currentSteps.filter(function(_, index) {
            return index < step;
        });
        setBreadcrumbs(filteredSteps);
    }, [
        step,
        setBreadcrumbs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(protected_page/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_sidebar_topbar/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home, {})
        })
    });
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 76166:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 82662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 28668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 44998:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 25892:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _wrapNativeSuper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(44998);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4306,8914,8255,2424,7640,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);